import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { IFloatingFilterParams } from 'ag-grid-community';
import { AgFloatingFilterComponent } from 'ag-grid-angular';
import { IntegrationService } from '../../../../shared/services/integration.service';
import { FormsModule } from '@angular/forms';
import { CdkOverlayOrigin, CdkConnectedOverlay } from '@angular/cdk/overlay';
import { NgClass } from '@angular/common';

@Component({
    selector: 'text-filter-component',
    templateUrl: './frequency-floating-filter.component.html',
    styleUrls: ['./frequency-floating-filter.component.scss'],
    standalone: true,
    imports: [FormsModule, CdkOverlayOrigin, NgClass, CdkConnectedOverlay]
})
export class FrequencyFloatingFilterComponent implements OnInit, AgFloatingFilterComponent {
  @ViewChild('eInput', { read: ElementRef, static: true }) eInput: ElementRef;
  params: IFloatingFilterParams;
  currentValue: Number | null | string = null;
  selectedValue: Number | null | string = null;
  isOpen: boolean;
  frequencyOptions = [
    'Weekly',
    'Every other week',
    'Twice a month',
    'Monthly',
    'Every 3 months',
    'Every 6 months',
    'Annually'
  ];
  public deleteIcon: string;
  constructor(private integrationService: IntegrationService) {}

  ngOnInit(): void {
    const assetUrl = this.integrationService.getApplicationPath();
    this.deleteIcon = assetUrl + 'assets/images/Delete.svg';
  }

  agInit(params: IFloatingFilterParams): void {
    this.params = params;
  }

  openMenu(): void {
    this.isOpen = !this.isOpen;
    if (this.currentValue) {
      this.selectedValue = this.currentValue;
    }
  }

  toggleFrequency(value): void {
    this.isOpen = value;
  }

  onParentModelChanged(parentModel: any): void {
    // When the filter is empty we will receive a null value here
    if (!parentModel) {
      this.currentValue = null;
    } else {
      this.currentValue = parentModel.filter;
    }
  }

  applyFrequency(): void {
    if (!this.selectedValue) {
      // Remove the filter
      this.params.parentFilterInstance((instance: any) => {
        instance.onFloatingFilterChanged(null, null);
      });
      this.isOpen = false;
      return;
    }
    this.currentValue = this.selectedValue;
    this.params.parentFilterInstance((instance: any) => {
      instance.onFloatingFilterChanged('equals', this.currentValue);
    });
    this.isOpen = false;
  }

  clearFrequency(event): void {
    event.preventDefault();
    this.selectedValue = null;
    this.applyFrequency();
  }
}
